import ReactDOM from 'react-dom';
import {
  Dispatch, SetStateAction, useRef, useState
 } from "react";
import { useOutside } from 'hooks/UseOutside';

import SuccessPentagon from '../../../../assets/img/success-pentagon.png';

import { ModalCloseButton, ModalContainer, ModalImage, ModalSection, ModalTitle } from './_notificationModal';

interface INotificationModalProps {
  toggleModal: Dispatch<SetStateAction<boolean>>;
  success?: boolean;
  message?: string;
  callback?: () => void;
}

export const NotificationModal = ({
  toggleModal,
  success = false,
  message,
  callback
}: INotificationModalProps) => {
  const modalRoot = document.getElementById('root-modal');
  const modalRef = useRef(null);

  const defaultMessage = success
    ? 'Alteração salva com sucesso!'
    : 'Erro ao salvar alteração!';

  const [hideModal, setHideModal] = useState(false);

  const handleCloseModal = () => {
    setHideModal((prevState) => !prevState);

    setTimeout(() => {
      toggleModal((prevState) => !prevState);

      if(callback){
        callback()
      }
    }, 500);
  }

  useOutside(modalRef, handleCloseModal);

  if(!modalRoot) {
    return null;
  }

  return ReactDOM.createPortal(
    <ModalSection className={`${hideModal ? 'modal-notification--hide' : ''}`}>
      <ModalContainer ref={modalRef}>
        <ModalCloseButton
          type="button"
          onClick={handleCloseModal}
        >
          X
        </ ModalCloseButton>
        <ModalTitle>
          {message || defaultMessage}
        </ModalTitle>
        <ModalImage src={SuccessPentagon} />
      </ModalContainer>
    </ModalSection>
    ,modalRoot
  )
}
